import { ReactElement } from 'react';
import { Button } from '../../shared/button/Button';
import styles from '../ProductDisplayPage.module.scss';

type Props = {
  onOpen: () => void;
};

export function WriteReviewButton({ onOpen }: Props): ReactElement {
  return (
    <Button
      text="Write A Review"
      onClick={onOpen}
      className={styles.review_button}
    />
  );
}
